module.exports = __webpack_public_path__ + "static/media/logos_google-ads.53a83618.svg";